import classNames from 'classnames';
import React from 'react';
import Skeleton from 'src/Components/Skeleton';
import styles from './styles.module.scss';

const StatisticsPlaceHolder = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: styles.header
  }), /*#__PURE__*/React.createElement(Skeleton, {
    className: styles.content
  }, Array(3).fill(0).map((_, index) => /*#__PURE__*/React.createElement("div", {
    className: styles.item,
    key: index
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: styles.icon
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapLabel
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: styles.label
  }), /*#__PURE__*/React.createElement(Skeleton, {
    className: styles.value
  }))))));
};

export default StatisticsPlaceHolder;